import React, { createContext, useContext, useState, useEffect } from "react";

//Firebase
import { firestore } from "../config/config";

//Context
import { AuthContext } from "./AuthContext";
import { ExcelContext } from "./ExcelContext";

// Context
export const FeedbackContext = createContext();
export const FeedbackActionContext = createContext();

const FeedbackContextProvider = (props) => {
  const { user } = useContext(AuthContext);
  const { readExcel, exportToExcel } = useContext(ExcelContext);

  //State
  const [feedbacks, setFeedbacks] = useState([]);

  useEffect(() => {
    if (user.uid !== undefined) {
      firestore
        .collection("feedbacks")
        .doc(user.uid)
        .collection("feeds")
        .orderBy("createdAt", "desc")
        .onSnapshot((docSnap) => {
          if (!docSnap.empty) {
            setFeedbacks(
              docSnap.docs.map((feeds) => {
                return {
                  createdAt: feeds.data().createdAt,
                  agentID: feeds.data().agentID,
                  clientID: feeds.data().clientID,
                  demand: feeds.data().demand,
                  final: feeds.data().final,
                  society: feeds.data().society,
                  block: feeds.data().block,
                  status: feeds.data().status,
                  phase: feeds.data().phase,
                  street: feeds.data().street,
                  category: feeds.data().category,
                  areaSize: feeds.data().areaSize,
                  areaType: feeds.data().areaType,
                  plotNo: feeds.data().plotNo,
                  precinct: feeds.data().precinct,
                  sector: feeds.data().sector,
                  feedID: feeds.id,
                };
              }),
            );
          }
        });
    }
  }, [user.uid]);

  // const fileHeader = ["name", "phoneNo", "email", "address"];

  // const exportFeedback = () => {
  //   exportToExcel([fileHeader], "Demo Agents File");
  // };

  const getRec = (id, state) => {
    firestore
      .collection("completeTask")
      .doc(id)
      .onSnapshot((doc) => state(doc.data().recURL));
  };

  return (
    <FeedbackContext.Provider value={{ feedbacks }}>
      <FeedbackActionContext.Provider value={{ getRec }}>
        {props.children}
      </FeedbackActionContext.Provider>
    </FeedbackContext.Provider>
  );
};

export default FeedbackContextProvider;
